import { render, staticRenderFns } from "./courier-region-info.vue?vue&type=template&id=8c264afa&scoped=true&"
import script from "./courier-region-info.js?vue&type=script&lang=js&"
export * from "./courier-region-info.js?vue&type=script&lang=js&"
import style0 from "./courier-region-info.scss?vue&type=style&index=0&id=8c264afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c264afa",
  null
  
)

export default component.exports